export const htmlFeatures = {
  plusIcon: '<button class="app-icon icon-plus"></button>',
};
